import { CSSProperties } from "@material-ui/core/styles/withStyles";
export { time } from "@clockwise/web-commons/src/styles/color.styles";
import { time, greys, colors } from "@clockwise/web-commons/src/styles/color.styles";

// STRUCTURE
export const container: CSSProperties = {
  padding: `15px 12px`,
};

export const weekContainer: CSSProperties = {
  display: "flex",
  flexDirection: "row",
};

// LEGEND
export const legendContainer: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  fontSize: 11,
  color: greys.slate,
};

export const legendLabel: CSSProperties = {
  marginRight: 10,
};

const legendDot: CSSProperties = {
  borderRadius: `50%`,
  height: 11,
  width: 11,
  marginRight: 5,
};

export const legendDotFocus: CSSProperties = {
  ...legendDot,
  backgroundColor: time.focus,
};

export const legendDotMeetings: CSSProperties = {
  ...legendDot,
  backgroundColor: time.busy,
};

export const legendDotFragmented: CSSProperties = {
  ...legendDot,
  backgroundColor: time.fragmented,
};

export const legendDotOther: CSSProperties = {
  ...legendDot,
  backgroundColor: time.other,
};

// LABELS
export const label: CSSProperties = {
  fontSize: 12,
  color: `rgba(142, 142, 147, 1)`,
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-end",
  WebkitFontSmoothing: "antialiased",
};

export const timeLabelColumn: CSSProperties = {
  ...label,
  fontSize: 11,
  flexDirection: "column",
  justifyContent: "space-between",
  width: 25,
  flexShrink: 0,
  paddingTop: 40,
  marginRight: 10,
};

export const sliderLabel: CSSProperties = {
  ...label,
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  marginTop: -40,
  pointerEvents: "none",
};

// Play / Pause button
export const controlsContainer: CSSProperties = {
  display: "flex",
  alignItems: "center",
};

export const playPauseButton = {
  style: { margin: `8px -2px 0 -11px` } as CSSProperties,
};

export const pauseIcon: CSSProperties = {
  color: greys.slate,
  height: 20,
  width: 20,
  "&:hover": {
    color: colors.yellow.darker,
  },
};

export const playIcon: CSSProperties = {
  color: greys.slate,
  height: 20,
  width: 20,
  "&:hover": {
    color: colors.green.darker,
  },
};

export const styles = {
  pauseIcon,
  playIcon,
};
